export function normalizeExternalUrl(value, network = "website") {
  const input = String(value || "").trim();
  if (!input) return "";
  if (/^https?:\/\//i.test(input)) return input;
  const handle = input.replace(/^@/, "").replace(/^\/+|\/+$/g, "");
  if (network === "instagram") return `https://www.instagram.com/${handle}`;
  if (network === "tiktok") return `https://www.tiktok.com/@${handle.replace(/^@/, "")}`;
  if (network === "youtube" && !input.includes(".")) return `https://www.youtube.com/@${handle}`;
  return `https://${input}`;
}
